import SessionEventProto from "../session-event-proto";
import {TemplatesCollection} from "../../model2/template/collection";

export default class SessionEvent_TemplatesReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        gd.session.templates = TemplatesCollection.initFromJson(this.data);
    }
};
